import { DigestTimingDay, MonthlyTimingKey } from '../model';

export const SHORT_DAY_LABELS = {
	[DigestTimingDay.SUNDAY]: 'digests.scheduling-labels.short-sunday',
	[DigestTimingDay.MONDAY]: 'digests.scheduling-labels.short-monday',
	[DigestTimingDay.TUESDAY]: 'digests.scheduling-labels.short-tuesday',
	[DigestTimingDay.WEDNESDAY]: 'digests.scheduling-labels.short-wednesday',
	[DigestTimingDay.THURSDAY]: 'digests.scheduling-labels.short-thursday',
	[DigestTimingDay.FRIDAY]: 'digests.scheduling-labels.short-friday',
	[DigestTimingDay.SATURDAY]: 'digests.scheduling-labels.short-saturday',
};

export const WEEK_LABELS: Record<MonthlyTimingKey, string> = {
	firstWeek: 'digests.scheduling-labels.first-week',
	secondWeek: 'digests.scheduling-labels.second-week',
	thirdWeek: 'digests.scheduling-labels.third-week',
	fourthWeek: 'digests.scheduling-labels.fourth-week',
	lastWeek: 'digests.scheduling-labels.last-week',
};

export const WEEKLY_LABEL_STRINGS = {
	[DigestTimingDay.SUNDAY]: 'digests.scheduling-labels.every-sunday',
	[DigestTimingDay.MONDAY]: 'digests.scheduling-labels.every-monday',
	[DigestTimingDay.TUESDAY]: 'digests.scheduling-labels.every-tuesday',
	[DigestTimingDay.WEDNESDAY]: 'digests.scheduling-labels.every-wednesday',
	[DigestTimingDay.THURSDAY]: 'digests.scheduling-labels.every-thursday',
	[DigestTimingDay.FRIDAY]: 'digests.scheduling-labels.every-friday',
	[DigestTimingDay.SATURDAY]: 'digests.scheduling-labels.every-saturday',
};

export const MONTHLY_LABEL_STRINGS: Record<MonthlyTimingKey, Record<DigestTimingDay, string>> = {
	firstWeek: {
		[DigestTimingDay.SUNDAY]: 'digests.scheduling-labels.every-first-sunday',
		[DigestTimingDay.MONDAY]: 'digests.scheduling-labels.every-first-monday',
		[DigestTimingDay.TUESDAY]: 'digests.scheduling-labels.every-first-tuesday',
		[DigestTimingDay.WEDNESDAY]: 'digests.scheduling-labels.every-first-wednesday',
		[DigestTimingDay.THURSDAY]: 'digests.scheduling-labels.every-first-thursday',
		[DigestTimingDay.FRIDAY]: 'digests.scheduling-labels.every-first-friday',
		[DigestTimingDay.SATURDAY]: 'digests.scheduling-labels.every-first-saturday',
	},
	secondWeek: {
		[DigestTimingDay.SUNDAY]: 'digests.scheduling-labels.every-second-sunday',
		[DigestTimingDay.MONDAY]: 'digests.scheduling-labels.every-second-monday',
		[DigestTimingDay.TUESDAY]: 'digests.scheduling-labels.every-second-tuesday',
		[DigestTimingDay.WEDNESDAY]: 'digests.scheduling-labels.every-second-wednesday',
		[DigestTimingDay.THURSDAY]: 'digests.scheduling-labels.every-second-thursday',
		[DigestTimingDay.FRIDAY]: 'digests.scheduling-labels.every-second-friday',
		[DigestTimingDay.SATURDAY]: 'digests.scheduling-labels.every-second-saturday',
	},
	thirdWeek: {
		[DigestTimingDay.SUNDAY]: 'digests.scheduling-labels.every-third-sunday',
		[DigestTimingDay.MONDAY]: 'digests.scheduling-labels.every-third-monday',
		[DigestTimingDay.TUESDAY]: 'digests.scheduling-labels.every-third-tuesday',
		[DigestTimingDay.WEDNESDAY]: 'digests.scheduling-labels.every-third-wednesday',
		[DigestTimingDay.THURSDAY]: 'digests.scheduling-labels.every-third-thursday',
		[DigestTimingDay.FRIDAY]: 'digests.scheduling-labels.every-third-friday',
		[DigestTimingDay.SATURDAY]: 'digests.scheduling-labels.every-third-saturday',
	},
	fourthWeek: {
		[DigestTimingDay.SUNDAY]: 'digests.scheduling-labels.every-fourth-sunday',
		[DigestTimingDay.MONDAY]: 'digests.scheduling-labels.every-fourth-monday',
		[DigestTimingDay.TUESDAY]: 'digests.scheduling-labels.every-fourth-tuesday',
		[DigestTimingDay.WEDNESDAY]: 'digests.scheduling-labels.every-fourth-wednesday',
		[DigestTimingDay.THURSDAY]: 'digests.scheduling-labels.every-fourth-thursday',
		[DigestTimingDay.FRIDAY]: 'digests.scheduling-labels.every-fourth-friday',
		[DigestTimingDay.SATURDAY]: 'digests.scheduling-labels.every-fourth-saturday',
	},
	lastWeek: {
		[DigestTimingDay.SUNDAY]: 'digests.scheduling-labels.every-last-sunday',
		[DigestTimingDay.MONDAY]: 'digests.scheduling-labels.every-last-monday',
		[DigestTimingDay.TUESDAY]: 'digests.scheduling-labels.every-last-tuesday',
		[DigestTimingDay.WEDNESDAY]: 'digests.scheduling-labels.every-last-wednesday',
		[DigestTimingDay.THURSDAY]: 'digests.scheduling-labels.every-last-thursday',
		[DigestTimingDay.FRIDAY]: 'digests.scheduling-labels.every-last-friday',
		[DigestTimingDay.SATURDAY]: 'digests.scheduling-labels.every-last-saturday',
	},
};

export const MONTH_DAY_SELECT_LABEL_STRINGS: Record<MonthlyTimingKey, Record<DigestTimingDay, string>> = {
	firstWeek: {
		[DigestTimingDay.SUNDAY]: 'digests.scheduling-labels.a11y-select-first-sunday',
		[DigestTimingDay.MONDAY]: 'digests.scheduling-labels.a11y-select-first-monday',
		[DigestTimingDay.TUESDAY]: 'digests.scheduling-labels.a11y-select-first-tuesday',
		[DigestTimingDay.WEDNESDAY]: 'digests.scheduling-labels.a11y-select-first-wednesday',
		[DigestTimingDay.THURSDAY]: 'digests.scheduling-labels.a11y-select-first-thursday',
		[DigestTimingDay.FRIDAY]: 'digests.scheduling-labels.a11y-select-first-friday',
		[DigestTimingDay.SATURDAY]: 'digests.scheduling-labels.a11y-select-first-saturday',
	},
	secondWeek: {
		[DigestTimingDay.SUNDAY]: 'digests.scheduling-labels.a11y-select-second-sunday',
		[DigestTimingDay.MONDAY]: 'digests.scheduling-labels.a11y-select-second-monday',
		[DigestTimingDay.TUESDAY]: 'digests.scheduling-labels.a11y-select-second-tuesday',
		[DigestTimingDay.WEDNESDAY]: 'digests.scheduling-labels.a11y-select-second-wednesday',
		[DigestTimingDay.THURSDAY]: 'digests.scheduling-labels.a11y-select-second-thursday',
		[DigestTimingDay.FRIDAY]: 'digests.scheduling-labels.a11y-select-second-friday',
		[DigestTimingDay.SATURDAY]: 'digests.scheduling-labels.a11y-select-second-saturday',
	},
	thirdWeek: {
		[DigestTimingDay.SUNDAY]: 'digests.scheduling-labels.a11y-select-third-sunday',
		[DigestTimingDay.MONDAY]: 'digests.scheduling-labels.a11y-select-third-monday',
		[DigestTimingDay.TUESDAY]: 'digests.scheduling-labels.a11y-select-third-tuesday',
		[DigestTimingDay.WEDNESDAY]: 'digests.scheduling-labels.a11y-select-third-wednesday',
		[DigestTimingDay.THURSDAY]: 'digests.scheduling-labels.a11y-select-third-thursday',
		[DigestTimingDay.FRIDAY]: 'digests.scheduling-labels.a11y-select-third-friday',
		[DigestTimingDay.SATURDAY]: 'digests.scheduling-labels.a11y-select-third-saturday',
	},
	fourthWeek: {
		[DigestTimingDay.SUNDAY]: 'digests.scheduling-labels.a11y-select-fourth-sunday',
		[DigestTimingDay.MONDAY]: 'digests.scheduling-labels.a11y-select-fourth-monday',
		[DigestTimingDay.TUESDAY]: 'digests.scheduling-labels.a11y-select-fourth-tuesday',
		[DigestTimingDay.WEDNESDAY]: 'digests.scheduling-labels.a11y-select-fourth-wednesday',
		[DigestTimingDay.THURSDAY]: 'digests.scheduling-labels.a11y-select-fourth-thursday',
		[DigestTimingDay.FRIDAY]: 'digests.scheduling-labels.a11y-select-fourth-friday',
		[DigestTimingDay.SATURDAY]: 'digests.scheduling-labels.a11y-select-fourth-saturday',
	},
	lastWeek: {
		[DigestTimingDay.SUNDAY]: 'digests.scheduling-labels.a11y-select-last-sunday',
		[DigestTimingDay.MONDAY]: 'digests.scheduling-labels.a11y-select-last-monday',
		[DigestTimingDay.TUESDAY]: 'digests.scheduling-labels.a11y-select-last-tuesday',
		[DigestTimingDay.WEDNESDAY]: 'digests.scheduling-labels.a11y-select-last-wednesday',
		[DigestTimingDay.THURSDAY]: 'digests.scheduling-labels.a11y-select-last-thursday',
		[DigestTimingDay.FRIDAY]: 'digests.scheduling-labels.a11y-select-last-friday',
		[DigestTimingDay.SATURDAY]: 'digests.scheduling-labels.a11y-select-last-saturday',
	},
};

export const MONTH_DAY_DESELECT_LABEL_STRINGS: Record<MonthlyTimingKey, Record<DigestTimingDay, string>> = {
	firstWeek: {
		[DigestTimingDay.SUNDAY]: 'digests.scheduling-labels.a11y-deselect-first-sunday',
		[DigestTimingDay.MONDAY]: 'digests.scheduling-labels.a11y-deselect-first-monday',
		[DigestTimingDay.TUESDAY]: 'digests.scheduling-labels.a11y-deselect-first-tuesday',
		[DigestTimingDay.WEDNESDAY]: 'digests.scheduling-labels.a11y-deselect-first-wednesday',
		[DigestTimingDay.THURSDAY]: 'digests.scheduling-labels.a11y-deselect-first-thursday',
		[DigestTimingDay.FRIDAY]: 'digests.scheduling-labels.a11y-deselect-first-friday',
		[DigestTimingDay.SATURDAY]: 'digests.scheduling-labels.a11y-deselect-first-saturday',
	},
	secondWeek: {
		[DigestTimingDay.SUNDAY]: 'digests.scheduling-labels.a11y-deselect-second-sunday',
		[DigestTimingDay.MONDAY]: 'digests.scheduling-labels.a11y-deselect-second-monday',
		[DigestTimingDay.TUESDAY]: 'digests.scheduling-labels.a11y-deselect-second-tuesday',
		[DigestTimingDay.WEDNESDAY]: 'digests.scheduling-labels.a11y-deselect-second-wednesday',
		[DigestTimingDay.THURSDAY]: 'digests.scheduling-labels.a11y-deselect-second-thursday',
		[DigestTimingDay.FRIDAY]: 'digests.scheduling-labels.a11y-deselect-second-friday',
		[DigestTimingDay.SATURDAY]: 'digests.scheduling-labels.a11y-deselect-second-saturday',
	},
	thirdWeek: {
		[DigestTimingDay.SUNDAY]: 'digests.scheduling-labels.a11y-deselect-third-sunday',
		[DigestTimingDay.MONDAY]: 'digests.scheduling-labels.a11y-deselect-third-monday',
		[DigestTimingDay.TUESDAY]: 'digests.scheduling-labels.a11y-deselect-third-tuesday',
		[DigestTimingDay.WEDNESDAY]: 'digests.scheduling-labels.a11y-deselect-third-wednesday',
		[DigestTimingDay.THURSDAY]: 'digests.scheduling-labels.a11y-deselect-third-thursday',
		[DigestTimingDay.FRIDAY]: 'digests.scheduling-labels.a11y-deselect-third-friday',
		[DigestTimingDay.SATURDAY]: 'digests.scheduling-labels.a11y-deselect-third-saturday',
	},
	fourthWeek: {
		[DigestTimingDay.SUNDAY]: 'digests.scheduling-labels.a11y-deselect-fourth-sunday',
		[DigestTimingDay.MONDAY]: 'digests.scheduling-labels.a11y-deselect-fourth-monday',
		[DigestTimingDay.TUESDAY]: 'digests.scheduling-labels.a11y-deselect-fourth-tuesday',
		[DigestTimingDay.WEDNESDAY]: 'digests.scheduling-labels.a11y-deselect-fourth-wednesday',
		[DigestTimingDay.THURSDAY]: 'digests.scheduling-labels.a11y-deselect-fourth-thursday',
		[DigestTimingDay.FRIDAY]: 'digests.scheduling-labels.a11y-deselect-fourth-friday',
		[DigestTimingDay.SATURDAY]: 'digests.scheduling-labels.a11y-deselect-fourth-saturday',
	},
	lastWeek: {
		[DigestTimingDay.SUNDAY]: 'digests.scheduling-labels.a11y-deselect-last-sunday',
		[DigestTimingDay.MONDAY]: 'digests.scheduling-labels.a11y-deselect-last-monday',
		[DigestTimingDay.TUESDAY]: 'digests.scheduling-labels.a11y-deselect-last-tuesday',
		[DigestTimingDay.WEDNESDAY]: 'digests.scheduling-labels.a11y-deselect-last-wednesday',
		[DigestTimingDay.THURSDAY]: 'digests.scheduling-labels.a11y-deselect-last-thursday',
		[DigestTimingDay.FRIDAY]: 'digests.scheduling-labels.a11y-deselect-last-friday',
		[DigestTimingDay.SATURDAY]: 'digests.scheduling-labels.a11y-deselect-last-saturday',
	},
};
